import { middlewares, methods } from './utils/reduxStore';
import connectionViewFiltersSlice from './slice/connectionViewFilter';
import connectionOnboardingSlice from './slice/connectionOnboarding';
import profileQuestionFiltersSlice from './slice/profileQuestionFilter';
import detailedConnectionOutcomesSlice from './slice/detailedConnectionOutcomes';
import detailedUserOutcomesSlice from './slice/detailedUserOutcomes';
import commonDetailsSlice from './slice/commonDetails';
import meetingFormSlice from './slice/meetingForm';
import lefNavSlice from './slice/leftNav';
import groupOverviewTabSlice from './slice/groupOverviewTab'
import eventsListingReducer from './slice/eventsListing'
import meetingFrequencyPopupSlice from './slice/meetingFrequencyPopup'
import meetingAgendaTabSlice from './slice/meetingAgendaTab';
import meetingGuideWidgetsSlice from './slice/meetingGuideWidgets';
import guidedConversationSlice from './slice/guidedConversation';
import meetingRatingReportFiltersSlice from './slice/meetingRatingReportFilter';
import expenseFormReducer from './slice/expense/form';
import expenseViewReducer from './slice/expenseView';
import eventViewReducer from './slice/eventView';
import budgetAnalyticsReducer from './slice/budgetAnalytics';
import layoutFlowSlice from './slice/layoutFlowForm';
import mentoringGoalQuestionnaireReducer from './slice/mentoringGoalQuestionnaire';
import mentoringGoalGamePlanReducer from './slice/mentoringGoalGamePlan';
import inAWordSlice from './slice/inAWord';
import homePageSlice from './slice/homePage';

export const chronusStore = methods.configureStore({
  reducer: {
    connectionViewFilter: connectionViewFiltersSlice.reducer,
    connectionOnboarding: connectionOnboardingSlice.reducer,
    profileQuestionFilter: profileQuestionFiltersSlice.reducer,
    detailedConnectionOutcomes: detailedConnectionOutcomesSlice.reducer,
    detailedUserOutcomes: detailedUserOutcomesSlice.reducer,
    commonDetails: commonDetailsSlice.reducer,
    meetingForm: meetingFormSlice.reducer,
    leftNav:lefNavSlice.reducer,
    meetingFrequencyPopup: meetingFrequencyPopupSlice.reducer,
    groupOverviewTab: groupOverviewTabSlice.reducer,
    eventsListing: eventsListingReducer,
    meetingAgendaTab: meetingAgendaTabSlice.reducer,
    meetingGuideWidgets: meetingGuideWidgetsSlice.reducer,
    guidedConversation: guidedConversationSlice.reducer,
    meetingRatingReportFilter: meetingRatingReportFiltersSlice.reducer,
    expenseForm: expenseFormReducer,
    expenseView: expenseViewReducer,
    eventView: eventViewReducer,
    budgetAnalytics: budgetAnalyticsReducer,
    layoutFlowForm: layoutFlowSlice.reducer,
    mentoringGoalQuestionnaire: mentoringGoalQuestionnaireReducer,
    mentoringGoalGamePlan: mentoringGoalGamePlanReducer,
    inAWord: inAWordSlice.reducer,
    homePage: homePageSlice.reducer
  },
  middleware: [middlewares.thunk]
});
